export default __webpack_public_path__ + "static/media/potionBottle.9e50a0fb.svg";